import React from 'react';

interface ILoggedIn{
    userName: string;
}

const LoggedIn = (props: ILoggedIn) => {

    const { userName } = props;

    return (
        <section className="text-center text-xl text-gray-700 w-full whitespace-nowrap overflow-hidden text-ellipsis">
            { userName }
        </section>
    )
};

export default LoggedIn;